module.exports = __webpack_public_path__ + "media/images/logo1-adab2a11cf81c77326761fc219420c45.png";